import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import ErrorList from './ErrorList/ErrorList';
import styles from './CSVModal.module.css';

const ErrorScreen = ({ title, selectedFile, error, onClearState, onClose }) => {
  const errorsList = get(error, 'value') || get(error, 'errors') || [];
  const message = get(error, 'message');

  return (
    <div className={`${styles.content} ${styles.contentLeft}`}>
      <h1>{title}</h1>
      <div className={styles.selectedFile}>
        <div>{selectedFile.name}</div>
        <button
          type="button"
          className={styles.closeFile}
          onClick={onClearState}
        >
          <i className="fal fa-times" />
        </button>
      </div>
      <p className={styles.error}>{message}</p>
      <h3>Fix the below errors before trying again:</h3>
      <ErrorList errorsList={errorsList} />
      <div className={styles.buttons}>
        <Button
          buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
          onClick={onClose}
          style={{ width: 120 }}
        >
          Cancel
        </Button>
        <Button onClick={onClearState} style={{ width: 177 }}>
          Retry Upload
        </Button>
      </div>
    </div>
  );
};

ErrorScreen.propTypes = {
  title: PropTypes.string.isRequired,
  selectedFile: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  error: PropTypes.shape({
    message: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string,
      })
    ),
  }).isRequired,
  onClearState: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorScreen;
